import { TermsAndConditionsModel } from "src/app/models/common/terms-and-conditions.model";
import { InsuranceModel } from "../quoteTable/base-quote.model";

export interface IQuoteModel {
    id?: string;
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    free_days?: number;
    price?: number;
    price_currency?: string;
    per_diem_currency?: string;
    per_diem?: number;
    negotiation_percent?: number;
    min_manufacturing_year?: number;
    max_manufacturing_year?: number;
    pickup_ready_date?: Date;
    purpose?: string;
    quote_valid_till?: Date;
    color_preference?: any;
    min_free_days?: number;
    max_free_days?: number;
    remarks?: string;
    pickup_charge_currency?: string;
    pickup_charge?: number;
    payee?: string;
    min_per_diem_currency?: string;
    min_per_diem?: number;
    max_per_diem_currency?: string;
    max_per_diem?: number;
    dpp_charge_currency?: string;
    dpp_charge?: number;
    storage_charge_currency?: string;
    storage_charge?: number;
    dropoff_charge_currency?: string;
    dropoff_charge?: number;
    cancellation_charge_currency?: string;
    cancellation_charge?: number;
    drv_new_build_price_currency?: string;
    drv_new_build_price?: number;
    min_late_charge_currency?: string;
    min_late_charge?: number;
    max_late_charge_currency?: string;
    max_late_charge?: number;
    drv_depreciation_per_year?: number;
    drv_max_depreciation_percent?: number;
    min_replacement_value?: number,
    min_replacement_value_currency?: string,
    quantity?: number;
    created_by?: string;
    updated_by?: string;
    requirement?: string;
    condition?: any;
    insurance?: InsuranceModel;
    insurance_premium: number;
    insurance_premium_currency: string;
    // insurance_premium_unit: any;
    container_size_type?: any;
    pol_list?: any;
    pod_list?: any;
    purchase_location?: any;
    terms_and_condition_fk: string | TermsAndConditionsModel;
    terms_and_condition_text: string;
    csc_revalidation_required: boolean;
    is_procurement: boolean;
    csc_revalidation_charge: number;
    csc_revalidation_charge_currency: string;
}

export interface IQuoteError {
    id: string[];
    updated_at: string[];
    created_at: string[];
    is_active: string[];
    free_days: string[];
    price: string[];
    price_currency: string[];
    per_diem_currency: string[];
    per_diem: string[];
    negotiation_percent: string[];
    min_manufacturing_year: string[];
    max_manufacturing_year: string[];
    pickup_ready_date: string[];
    purpose: string[];
    quote_valid_till: string[];
    color_preference: string[];
    min_free_days: string[];
    max_free_days: string[];
    remarks: string[];
    pickup_charge_currency: string[];
    pickup_charge: string[];
    min_per_diem_currency: string[];
    min_per_diem: string[];
    max_per_diem_currency: string[];
    max_per_diem: string[];
    dpp_charge_currency: string[];
    dpp_charge: string[];
    storage_charge_currency: string[];
    storage_charge: string[];
    dropoff_charge_currency: string[];
    dropoff_charge: string[];
    cancellation_charge_currency: string[];
    cancellation_charge: string[];
    drv_new_build_price_currency: string[];
    drv_new_build_price: string[];
    min_late_charge_currency: string[];
    min_late_charge: string[];
    max_late_charge_currency: string[];
    max_late_charge: string[];
    drv_depreciation_per_year: string[];
    drv_max_depreciation_percent: string[];
    min_replacement_value: string[];
    min_replacement_value_currency: string[];
    quantity: string[];
    created_by: string[];
    updated_by: string[];
    requirement: string[];
    condition: string[];
    insurance: string[];
    insurance_premium: string[];
    insurance_premium_currency: string[];
    payee: string[];
    // insurance_premium_unit: string[];
    terms_and_condition_fk: string[];
    terms_and_condition_text: string[];
    csc_revalidation_required: string[];
    csc_revalidation_charge: string[];
    csc_revalidation_charge_currency: string[];
}

export interface LQuoteModel {
    id: string;
    is_active: boolean;
    quote_number: string;
    quantity: string;
    quote_valid_till: string;
    remarks: string;
    terms_condition_policy: string;
    per_diem_charge_currency: string;
    per_diem_charge: string;
    negotiation_percent: string;
    tentative_pickup_date: string;
    build_up_period_days: string;
    build_down_period_days: string;
    post_build_down_per_diem_charge_currency: string;
    post_build_down_per_diem_charge: string;
    ero_after_days: string;
    ero_penalty_per_diem_charge_currency: string;
    ero_penalty_per_diem_charge: string;
    ero_notice_period_days: string;
    drv_new_build_price_currency: string;
    drv_new_build_price: string;
    drv_depreciation_per_year: string;
    drv_max_depreciation_percent: string;
    container_deemed_lost_after_days: string;
    notice_period_amendment_delivery_days: string;
    notice_period_amendment_return_days: string;
    document: string;
    requirement: string;
    container_condition: string;
    pol_list: any;
    pod_list: any;
    is_ero_enabled: boolean;
    ero: LeaseERODetailsModel[]
}

export interface LQuoteError {
    id: string[];
    terms_condition: string[];
    updated_at: string[];
    created_at: string[];
    is_active: string[];
    quote_number: string[];
    quantity: string[];
    quote_valid_till: string[];
    remarks: string[];
    terms_condition_policy: string[];
    per_diem_charge_currency: string[];
    per_diem_charge: string[];
    negotiation_percent: string[];
    tentative_pickup_date: string[];
    build_up_period_days: string[];
    build_down_period_days: string[];
    post_build_down_per_diem_charge_currency: string[];
    post_build_down_per_diem_charge: string[];
    ero_after_days: string[];
    ero_penalty_per_diem_charge_currency: string[];
    ero_penalty_per_diem_charge: string[];
    ero_notice_period_days: string[];
    drv_new_build_price_currency: string[];
    drv_new_build_price: string[];
    drv_depreciation_per_year: string[];
    drv_max_depreciation_percent: string[];
    container_deemed_lost_after_days: string[];
    notice_period_amendment_delivery_days: string[];
    notice_period_amendment_return_days: string[];
    created_by: string[];
    updated_by: string[];
    document: string[];
    requirement: string[];
    container_condition: string[];
    is_ero_enabled: string[],
    minimum_rental_period_days: string[],
    ero: string[]
}

export interface CommercialDetails {
    results: INegotiationModel[]
}

export interface INegotiationModel {
    id?: string;
    // internal_quote?: IQuoteModel;
    // external_quote?: IQuoteModel;
    latest_quote?: IQuoteModel;
    last_quote?: LQuoteModel;
}

export class QuoteModel implements IQuoteModel {
    updated_at?: Date;
    created_at?: Date;
    is_active?: boolean;
    free_days?: number;
    price?: number;
    price_currency?: string;
    per_diem_currency?: string;
    per_diem?: number;
    negotiation_percent?: number;
    min_manufacturing_year?: number;
    max_manufacturing_year?: number;
    pickup_ready_date?: Date;
    purpose?: string;
    quote_valid_till?: Date;
    color_preference?: any;
    min_free_days?: number;
    max_free_days?: number;
    remarks?: string;
    pickup_charge_currency?: string;
    pickup_charge?: number;
    payee?: string;
    min_per_diem_currency?: string;
    min_per_diem?: number;
    max_per_diem_currency?: string;
    max_per_diem?: number;
    dpp_charge_currency?: string;
    dpp_charge?: number;
    storage_charge_currency?: string;
    storage_charge?: number;
    dropoff_charge_currency?: string;
    dropoff_charge?: number;
    cancellation_charge_currency?: string;
    cancellation_charge?: number;
    drv_new_build_price_currency?: string;
    drv_new_build_price?: number;
    min_late_charge_currency?: string;
    min_late_charge?: number;
    max_late_charge_currency?: string;
    max_late_charge?: number;
    drv_depreciation_per_year?: number;
    drv_max_depreciation_percent?: number;
    min_replacement_value?: number;
    min_replacement_value_currency?: string;
    quantity?: number;
    created_by?: string;
    updated_by?: string;
    requirement?: string;
    condition?: any;
    insurance?: InsuranceModel;
    insurance_premium: number;
    insurance_premium_currency: string;
    container_size_type?: any;
    pol_list?: any;
    pod_list?: any;
    purchase_location?: any;
    // insurance_premium_unit: any;
    csc_revalidation_required: boolean;
    is_procurement: boolean;
    csc_revalidation_charge: number;
    csc_revalidation_charge_currency: string;
    terms_and_condition_fk: string | TermsAndConditionsModel;
    terms_and_condition_text: string;
    amount: number;
    amount_currency: string;

    error: IQuoteError;

    constructor() {
        this.is_active = true;
        this.free_days = null;
        this.price = null;
        this.price_currency = 'USD';
        this.per_diem = null;
        this.per_diem_currency = 'USD';
        this.negotiation_percent = null;
        this.min_manufacturing_year = 2005;
        this.max_manufacturing_year = 2023;
        this.pickup_ready_date = null;
        this.purpose = null;
        this.quote_valid_till = null;
        this.color_preference = null;
        this.min_free_days = null;
        this.max_free_days = null;
        this.remarks = null;
        this.pickup_charge_currency = 'USD';
        this.pickup_charge = null;
        this.payee = null;
        this.min_per_diem_currency = 'USD';
        this.min_per_diem = null;
        this.max_per_diem_currency = 'USD';
        this.max_per_diem = null;
        this.dpp_charge_currency = 'USD';
        this.dpp_charge = null;
        this.storage_charge_currency = 'USD';
        this.storage_charge = null;
        this.dropoff_charge_currency = 'USD';
        this.dropoff_charge = null;
        this.cancellation_charge_currency = 'USD';
        this.cancellation_charge = null;
        this.drv_new_build_price_currency = 'USD';
        this.drv_new_build_price = null;
        this.min_late_charge_currency = 'USD';
        this.min_late_charge = null;
        this.max_late_charge_currency = 'USD';
        this.max_late_charge = null;
        this.drv_depreciation_per_year = null;
        this.drv_max_depreciation_percent = null;
        this.min_replacement_value = null;
        this.min_replacement_value_currency = 'USD';
        this.quantity = null;
        this.requirement = null;
        // this.condition = null;
        this.insurance = null;
        this.created_at = null;
        this.insurance_premium = null;
        this.insurance_premium_currency = 'USD';
        this.container_size_type = null;
        this.condition = null;
        this.pol_list = null;
        this.pod_list = null;
        // this.insurance_premium_unit = null;
        this.purchase_location = null;
        this.csc_revalidation_required = true;
        this.is_procurement = false;
        this.csc_revalidation_charge = null;
        this.csc_revalidation_charge_currency = 'USD';
        this.terms_and_condition_fk = null;
        this.terms_and_condition_text = null;

        this.resetErrors();
    }

    resetErrors() {
        this.error = {
            id: [],
            updated_at: [],
            created_at: [],
            is_active: [],
            free_days: [],
            price: [],
            price_currency: [],
            per_diem_currency: [],
            per_diem: [],
            negotiation_percent: [],
            min_manufacturing_year: [],
            max_manufacturing_year: [],
            pickup_ready_date: [],
            purpose: [],
            quote_valid_till: [],
            color_preference: [],
            min_free_days: [],
            max_free_days: [],
            remarks: [],
            pickup_charge_currency: [],
            pickup_charge: [],
            min_per_diem_currency: [],
            min_per_diem: [],
            max_per_diem_currency: [],
            max_per_diem: [],
            dpp_charge_currency: [],
            dpp_charge: [],
            storage_charge_currency: [],
            storage_charge: [],
            dropoff_charge_currency: [],
            dropoff_charge: [],
            cancellation_charge_currency: [],
            cancellation_charge: [],
            drv_new_build_price_currency: [],
            drv_new_build_price: [],
            min_late_charge_currency: [],
            min_late_charge: [],
            max_late_charge_currency: [],
            max_late_charge: [],
            drv_depreciation_per_year: [],
            drv_max_depreciation_percent: [],
            min_replacement_value: [],
            min_replacement_value_currency: [],
            quantity: [],
            created_by: [],
            updated_by: [],
            requirement: [],
            condition: [],
            insurance: [],
            insurance_premium: [],
            insurance_premium_currency: [],
            payee: [],
            // insurance_premium_unit: [],
            csc_revalidation_required: [],
            csc_revalidation_charge: [],
            csc_revalidation_charge_currency: [],
            terms_and_condition_fk: [],
            terms_and_condition_text: [],
        }
    }

    // is_valid() {
    //     return Object.keys(this.error).map((key) => {
    //         return this.error[key].length;
    //     }).reduce((a, b) => a + b, 0) == 0;
    // }
    is_valid(request, isCustomer) {
        this.resetErrors();

        if (this.quantity == null) {
            this.error.quantity.push('Quantity should not be null');
        }
        if (!isCustomer && this.quote_valid_till == null) {
            this.error.quote_valid_till.push('Please select quotation validity date');
        }

        if (request.request_type.dev_name == 'one_way') {
            if (this.pickup_charge == null) {
                this.error.pickup_charge.push('Pick-up charge should not be null');
            }
            if (this.payee == null) {
                this.error.payee.push('Please select a payee');
            }
            if (this.min_free_days == null) {
                this.error.min_free_days.push('Free days should not be null');
            }
            if (this.min_per_diem == null) {
                this.error.min_per_diem.push('Per Diem charge should not be null');
            }
            if (this.dpp_charge == null) {
                this.error.dpp_charge.push('DPP charge should not be null');
            }
            if (this.storage_charge == null) {
                this.error.storage_charge.push('Storage charge should not be null');
            }
            if (this.cancellation_charge == null) {
                this.error.cancellation_charge.push('Cancellation charge should not be null');
            }
            if (this.drv_new_build_price == null) {
                this.error.drv_new_build_price.push('New Build price should not be null');
            }
            if (this.drv_depreciation_per_year == null) {
                this.error.drv_depreciation_per_year.push('Depreciation charge should not be null');
            }
            if (this.drv_max_depreciation_percent == null) {
                this.error.drv_max_depreciation_percent.push('Max Depreciation charge should not be null');
            }
            // if (this.insurance == null) {
            //     this.error.insurance.push('Please select an insurance');
            // }

            return this.error.quantity.length == 0 &&
                this.error.pickup_charge.length == 0 &&
                this.error.payee.length == 0 &&
                this.error.min_free_days.length == 0 &&
                this.error.min_per_diem.length == 0 &&
                this.error.dpp_charge.length == 0 &&
                this.error.storage_charge.length == 0 &&
                this.error.cancellation_charge.length == 0 &&
                this.error.drv_new_build_price.length == 0 &&
                this.error.drv_depreciation_per_year.length == 0 &&
                this.error.drv_max_depreciation_percent.length == 0 &&
                this.error.insurance.length == 0 &&
                this.error.quote_valid_till.length == 0
        }

        if (request.request_type.dev_name == 'buy_sell') {
            if (this.price == null) {
                this.error.price.push('Price should not be null');
            }
            if (this.storage_charge == null) {
                this.error.storage_charge.push('Storage charge should not be null');
            }
            if (this.condition == null) {
                this.error.condition.push('Please select condition of container');
            }

            return this.error.quantity.length == 0 &&
                this.error.price.length == 0 &&
                this.error.storage_charge.length == 0 &&
                this.error.condition.length == 0 &&
                this.error.quote_valid_till.length == 0
        }
    }

    saveOneWayQuoteToModel(data: IQuoteModel) {
        this.quantity = data.quantity;
        this.pickup_charge_currency = data.pickup_charge_currency;
        this.pickup_charge = data.pickup_charge;
        this.payee = data.payee;
        this.min_free_days = data.min_free_days;
        this.max_free_days = data.max_free_days;
        this.min_per_diem_currency = data.min_per_diem_currency;
        this.min_per_diem = data.min_per_diem;
        this.max_per_diem_currency = data.max_per_diem_currency;
        this.max_per_diem = data.max_per_diem;
        this.dpp_charge_currency = data.dpp_charge_currency;
        this.dpp_charge = data.dpp_charge;
        this.storage_charge_currency = data.storage_charge_currency;
        this.storage_charge = data.storage_charge;
        this.dropoff_charge_currency = data.dropoff_charge_currency;
        this.dropoff_charge = data.dropoff_charge;
        this.cancellation_charge_currency = data.cancellation_charge_currency;
        this.cancellation_charge = data.cancellation_charge;
        this.drv_new_build_price_currency = data.drv_new_build_price_currency;
        this.drv_new_build_price = data.drv_new_build_price;
        this.drv_depreciation_per_year = data.drv_depreciation_per_year;
        this.drv_max_depreciation_percent = data.drv_max_depreciation_percent;
        this.insurance = data.insurance;
        this.insurance_premium = data.insurance_premium;
        this.insurance_premium_currency = data.insurance_premium_currency;
        this.quote_valid_till = data.quote_valid_till;
        this.remarks = data.remarks;
        this.is_active = data.is_active;
        this.min_late_charge_currency = data.min_late_charge_currency;
        this.min_late_charge = data.min_late_charge;
        this.max_late_charge_currency = data.max_late_charge_currency;
        this.max_late_charge = data.max_late_charge;
        this.min_replacement_value = data.min_replacement_value;
        this.min_replacement_value_currency = data.min_replacement_value_currency;
        this.requirement = data.requirement;
        // this.insurance_premium_unit = data.insurance_premium_unit;
        this.created_at = data.created_at;
        this.terms_and_condition_fk = data.terms_and_condition_fk;
        this.terms_and_condition_text = data.terms_and_condition_text;
        this.pol_list = data.pol_list;
        this.pod_list = data.pod_list;
    }

    saveTradeQuoteToModel(data: IQuoteModel) {
        this.quantity = data.quantity;
        this.price = data.price;
        this.price_currency = data.price_currency;
        this.storage_charge = data.storage_charge;
        this.storage_charge_currency = data.storage_charge_currency;
        this.min_manufacturing_year = data.min_manufacturing_year;
        this.max_manufacturing_year = data.max_manufacturing_year;
        this.color_preference = data.color_preference;
        this.condition = data.condition;
        this.purpose = data.purpose;
        this.pickup_ready_date = data.pickup_ready_date;
        this.quote_valid_till = data.quote_valid_till;
        this.per_diem = data.per_diem;
        this.per_diem_currency = data.per_diem_currency;
        this.negotiation_percent = data.negotiation_percent;
        this.free_days = data.free_days;
        this.is_active = data.is_active;
        this.remarks = data.remarks;
        this.created_at = data.created_at;
        this.purchase_location = data.purchase_location;
        this.csc_revalidation_required = data.csc_revalidation_required;
        this.is_procurement = data.is_procurement;
        this.csc_revalidation_charge = data.csc_revalidation_charge;
        this.csc_revalidation_charge_currency = data.csc_revalidation_charge_currency;

        this.terms_and_condition_fk = data.terms_and_condition_fk;
        this.terms_and_condition_text = data.terms_and_condition_text;

    }

    saveLeaseQuoteToModel(data: IQuoteModel) { }

    getSavePayload(request) {
        switch (request.request_type.dev_name) {
            case 'lease':
                return {}
            case 'one_way':
                return {
                    is_active: this.is_active,
                    free_days: this.free_days,
                    price: this.price,
                    price_currency: this.price_currency,
                    per_diem: this.per_diem,
                    per_diem_currency: this.per_diem_currency,
                    min_free_days: this.min_free_days,
                    max_free_days: this.max_free_days,
                    remarks: this.remarks,
                    pickup_charge_currency: this.pickup_charge_currency,
                    pickup_charge: this.pickup_charge,
                    payee: this.payee,
                    min_per_diem_currency: this.min_per_diem_currency,
                    min_per_diem: this.min_per_diem,
                    max_per_diem_currency: this.max_per_diem_currency,
                    max_per_diem: this.max_per_diem,
                    dpp_charge_currency: this.dpp_charge_currency,
                    dpp_charge: this.dpp_charge,
                    storage_charge_currency: this.storage_charge_currency,
                    storage_charge: this.storage_charge,
                    dropoff_charge_currency: this.dropoff_charge_currency,
                    dropoff_charge: this.dropoff_charge,
                    cancellation_charge_currency: this.cancellation_charge_currency,
                    cancellation_charge: this.cancellation_charge,
                    drv_new_build_price_currency: this.drv_new_build_price_currency,
                    drv_new_build_price: this.drv_new_build_price,
                    min_late_charge_currency: this.min_late_charge_currency,
                    min_late_charge: this.min_late_charge,
                    max_late_charge_currency: this.max_late_charge_currency,
                    max_late_charge: this.max_late_charge,
                    drv_depreciation_per_year: this.drv_depreciation_per_year,
                    drv_max_depreciation_percent: this.drv_max_depreciation_percent,
                    min_replacement_value: this.min_replacement_value,
                    min_replacement_value_currency: this.min_replacement_value_currency,
                    quantity: this.quantity,
                    requirement: this.requirement,
                    insurance: typeof this.insurance == 'object' && this.insurance != null ? this.insurance.id : this.insurance,
                    insurance_premium: this.insurance_premium,
                    insurance_premium_currency: this.insurance_premium_currency,
                    // insurance_premium_unit: this.insurance_premium_unit,
                    quote_valid_till: this.quote_valid_till,
                    container_size_type: typeof this.container_size_type == 'object' && this.container_size_type != null ? this.container_size_type.id : this.container_size_type,
                    condition: typeof this.condition == 'object' && this.condition != null ? this.condition.id : this.condition,
                    pol_list: this.pol_list.map((item) => item.id),
                    pod_list: this.pod_list.map((item) => item.id),
                    terms_and_condition_fk: typeof this.terms_and_condition_fk == 'object' && this.terms_and_condition_fk != null ? this.terms_and_condition_fk.id : this.terms_and_condition_fk,
                    terms_and_condition_text: this.terms_and_condition_text,
                }
            case 'buy_sell':
                return {
                    is_active: this.is_active,
                    free_days: this.free_days,
                    price: this.price,
                    price_currency: this.price_currency,
                    storage_charge: this.storage_charge,
                    storage_charge_currency: this.storage_charge_currency,
                    per_diem: this.per_diem,
                    per_diem_currency: this.per_diem_currency,
                    quantity: this.quantity,
                    negotiation_percent: this.negotiation_percent,
                    min_manufacturing_year: this.min_manufacturing_year,
                    max_manufacturing_year: this.max_manufacturing_year,
                    pickup_ready_date: this.pickup_ready_date,
                    purpose: this.purpose,
                    quote_valid_till: this.quote_valid_till,
                    remarks: this.remarks,
                    color_preference: typeof this.color_preference == 'object' && this.color_preference != null ? this.color_preference.id : this.color_preference,
                    condition: typeof this.condition == 'object' && this.condition != null ? this.condition.id : this.condition,
                    csc_revalidation_required: this.csc_revalidation_required,
                    csc_revalidation_charge: this.csc_revalidation_required ? null : this.csc_revalidation_charge,
                    csc_revalidation_charge_currency: this.csc_revalidation_charge_currency,
                    terms_and_condition_fk: typeof this.terms_and_condition_fk == 'object' && this.terms_and_condition_fk != null ? this.terms_and_condition_fk.id : this.terms_and_condition_fk,
                    terms_and_condition_text: this.terms_and_condition_text,
                    purchase_location: this.purchase_location.map((item) => item.id)

                }
        }
    }
}

export class LeaseQuoteModel {
    id: string;
    is_active: boolean;
    quote_number: string;
    quantity: string;
    quote_valid_till: string;
    remarks: string;
    terms_condition_policy: string;
    per_diem_charge_currency: string;
    per_diem_charge: string;
    negotiation_percent: string;
    tentative_pickup_date: string;
    build_up_period_days: string;
    build_down_period_days: string;
    post_build_down_per_diem_charge_currency: string;
    post_build_down_per_diem_charge: string;
    ero_after_days: string;
    ero_penalty_per_diem_charge_currency: string;
    ero_penalty_per_diem_charge: string;
    ero_notice_period_days: string;
    drv_new_build_price_currency: string;
    drv_new_build_price: string;
    drv_depreciation_per_year: string;
    drv_max_depreciation_percent: string;
    container_deemed_lost_after_days: string;
    notice_period_amendment_delivery_days: string;
    notice_period_amendment_return_days: string;
    document: string;
    requirement: string;
    container_condition: string;
    pol_list: any;
    pod_list: any;
    is_ero_enabled: boolean;
    ero: [];
    minimum_rental_period_days: number;
    error: LQuoteError;
    drv_max_depreciation_price:number;
    drv_max_depreciation_price_currency:string;

    constructor() {
        this.id = null;
        this.is_active = false;
        this.quote_number = null;
        this.quantity = null;
        this.quote_valid_till = null;
        this.remarks = null;
        this.terms_condition_policy = null;
        this.per_diem_charge_currency = 'USD';
        this.per_diem_charge = null;
        this.negotiation_percent = null;
        this.tentative_pickup_date = null;
        this.build_up_period_days = null;
        this.build_down_period_days = null;
        this.post_build_down_per_diem_charge_currency = 'USD';
        this.post_build_down_per_diem_charge = null;
        this.ero_after_days = null;
        this.ero_penalty_per_diem_charge_currency = 'USD';
        this.ero_penalty_per_diem_charge = null;
        this.ero_notice_period_days = null;
        this.drv_new_build_price_currency = 'USD';
        this.drv_new_build_price = null;
        this.drv_depreciation_per_year = null;
        this.drv_max_depreciation_percent = null;
        this.container_deemed_lost_after_days = null;
        this.notice_period_amendment_delivery_days = null;
        this.notice_period_amendment_return_days = null;
        this.document = null;
        this.requirement = null;
        this.container_condition = null;
        this.pol_list = null;
        this.pod_list = null;
        this.ero = [];
        this.is_ero_enabled = false;
        this.minimum_rental_period_days = null;
        this.drv_max_depreciation_price = null;
        this.drv_max_depreciation_price_currency = null;
        this.resetLeaseErrors();
    }

    resetLeaseErrors() {
        this.error = {
            id: [],
            terms_condition: [],
            updated_at: [],
            created_at: [],
            is_active: [],
            quote_number: [],
            quantity: [],
            quote_valid_till: [],
            remarks: [],
            terms_condition_policy: [],
            per_diem_charge_currency: [],
            per_diem_charge: [],
            negotiation_percent: [],
            tentative_pickup_date: [],
            build_up_period_days: [],
            build_down_period_days: [],
            post_build_down_per_diem_charge_currency: [],
            post_build_down_per_diem_charge: [],
            ero_after_days: [],
            ero_penalty_per_diem_charge_currency: [],
            ero_penalty_per_diem_charge: [],
            ero_notice_period_days: [],
            drv_new_build_price_currency: [],
            drv_new_build_price: [],
            drv_depreciation_per_year: [],
            drv_max_depreciation_percent: [],
            container_deemed_lost_after_days: [],
            notice_period_amendment_delivery_days: [],
            notice_period_amendment_return_days: [],
            created_by: [],
            updated_by: [],
            document: [],
            requirement: [],
            container_condition: [],
            is_ero_enabled: [],
            minimum_rental_period_days: [],
            ero: []
        }
    }

    // saveLeaseQuoteToModel(data: LQuoteModel) {
    //     this.id = data.id;
    //     this.is_active = data.is_active;
    //     this.quote_number = data.quote_number;
    //     this.quantity = data.quantity;
    //     this.quote_valid_till = data.quote_valid_till;
    //     this.remarks = data.remarks;
    //     this.terms_condition_policy = data.terms_condition_policy;
    //     this.per_diem_charge_currency = data.per_diem_charge_currency;
    //     this.per_diem_charge = data.per_diem_charge;
    //     this.negotiation_percent = data.negotiation_percent;
    //     this.tentative_pickup_date = data.tentative_pickup_date;
    //     this.build_up_period_days = data.build_up_period_days;
    //     this.build_down_period_days = data.build_down_period_days;
    //     this.post_build_down_per_diem_charge_currency = data.post_build_down_per_diem_charge_currency;
    //     this.post_build_down_per_diem_charge = data.post_build_down_per_diem_charge;
    //     this.ero_after_days = data.ero_after_days;
    //     this.ero_penalty_per_diem_charge_currency = data.ero_penalty_per_diem_charge_currency;
    //     this.ero_penalty_per_diem_charge = data.ero_penalty_per_diem_charge;
    //     this.ero_notice_period_days = data.ero_notice_period_days;
    //     this.drv_new_build_price_currency = data.drv_new_build_price_currency;
    //     this.drv_new_build_price = data.drv_new_build_price;
    //     this.drv_depreciation_per_year = data.drv_depreciation_per_year;
    //     this.drv_max_depreciation_percent = data.drv_max_depreciation_percent;
    //     this.document = data.document;
    //     this.requirement = data.requirement;
    //     this.container_condition = data.container_condition;
    //     this.pol_list = data.pol_list;
    //     this.pod_list = data.pod_list;
    // }

    getSavePayload() {
        return {
            id: this.id,
            is_active: this.is_active,
            quote_number: this.quote_number,
            quantity: this.quantity,
            quote_valid_till: this.quote_valid_till,
            remarks: this.remarks,
            terms_condition_policy: this.terms_condition_policy,
            per_diem_charge_currency: this.per_diem_charge_currency,
            per_diem_charge: this.per_diem_charge,
            negotiation_percent: this.negotiation_percent,
            tentative_pickup_date: this.tentative_pickup_date,
            build_up_period_days: this.build_up_period_days,
            build_down_period_days: this.build_down_period_days,
            post_build_down_per_diem_charge_currency: this.post_build_down_per_diem_charge_currency,
            post_build_down_per_diem_charge: this.post_build_down_per_diem_charge,
            ero_after_days: this.ero_after_days,
            ero_penalty_per_diem_charge_currency: this.ero_penalty_per_diem_charge_currency,
            ero_penalty_per_diem_charge: this.ero_penalty_per_diem_charge,
            ero_notice_period_days: this.ero_notice_period_days,
            drv_new_build_price_currency: this.drv_new_build_price_currency,
            drv_new_build_price: this.drv_new_build_price,
            drv_depreciation_per_year: this.drv_depreciation_per_year,
            drv_max_depreciation_percent: this.drv_max_depreciation_percent,
            container_deemed_lost_after_days: this.container_deemed_lost_after_days,
            notice_period_amendment_delivery_days: this.notice_period_amendment_delivery_days,
            notice_period_amendment_return_days: this.notice_period_amendment_return_days,
            document: this.document,
            requirement: this.requirement,
            container_condition: this.container_condition,
            pol_list: this.pol_list,
            pod_list: this.pod_list,
            is_ero_enabled: this.is_ero_enabled,
            minimum_rental_period_days: this.minimum_rental_period_days,
            ero: this.ero,
            drv_max_depreciation_price : this.drv_max_depreciation_price,
            drv_max_depreciation_price_currency :this.drv_max_depreciation_price_currency,
        }
    }
}

export class NegotiationModel implements INegotiationModel {
    id?: string;
    // internal_quote: QuoteModel;
    // external_quote: QuoteModel;
    latest_quote: QuoteModel;
    last_quote?: LeaseQuoteModel;

    constructor() {
        // this.internal_quote = new QuoteModel();
        // this.external_quote = new QuoteModel();
        this.latest_quote = new QuoteModel();
        this.last_quote = new LeaseQuoteModel();
    }

    setPayload(data: INegotiationModel, request) {
        if (data == null) {
            return;
        }

        this.id = data.id;
        switch (request.request_type.dev_name) {
            case 'lease':
                if (data.last_quote != null) {
                    // this.last_quote.saveLeaseQuoteToModel(data.last_quote);
                }
                break;
            case 'one_way':
                if (data.latest_quote != null) {
                    this.latest_quote.saveOneWayQuoteToModel(data.latest_quote);
                    if (this.latest_quote.pol_list.length == 0) {
                        this.latest_quote.pol_list = request.pols;
                    }
                    if (this.latest_quote.pod_list.length == 0) {
                        this.latest_quote.pod_list = request.pods;
                    }
                }
                break;
            case 'buy_sell':
                if (data.latest_quote != null) {
                    this.latest_quote.saveTradeQuoteToModel(data.latest_quote);
                    if (this.latest_quote.pol_list.length == 0) {
                        this.latest_quote.pol_list = request.pols;
                    }
                }
                break;
        }
    }
}

export class LeaseERODetailsModel {
    sequence_no: number;
    fromDays: number;
    toDays: number;
    days: number;
    amount: number;
    amount_currency: string;
    penalty_from: string;
    lease: string;
    lease_id: string;

    constructor() {
        this.sequence_no = null;
        this.fromDays = null;
        this.toDays = null;
        this.days = null;
        this.amount = null;
        this.amount_currency = null;
        this.penalty_from = null;
        this.lease = null;
        this.lease_id = null;
    }
}
